import React, { Component, useEffect, useState } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import Pagination from "../Std/Pagination";
import * as utilities from "../../utilities/utils";
import moment from "moment";
import DropdownComponent from "../../containers/Dropdown";
import { PAGE_SIZE_DRP } from "../../App.config";
import history from "../../utilities/history";
import Backbutton from "../../containers/Common/Backbutton";
import CaseStatus from "../../containers/CaseStatus";
import ErsCaseStatusDetailModal from "../../containers/ErsApplicant/ErsCaseStatusDetailModal";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";
import SearchComponent from '../SearchComponent';

const initialState = {
  searchKeyword: {
    value: "",
    error: "",
    validation: {
      required: true,
    },
  },
  isGridView: true,
};
const ErsApplicantComponent = (props, context) => {
  const [state, setstate] = useState(initialState);

  // Set state to initial state on change component
  useEffect(() => {
    return () => {
      setstate((state) => {
        return {
          ...initialState,
        };
      });
    };
  }, []);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = { ...state[name] };
    updatedObj.value = type === "checkbox" ? checked : value.trimLeft();

    setstate((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const onClickAttachment = (ein) => {
    history.push(`/attachments?ein=${ein}`);
  };

  const onViewChange = (view) => {
    setstate((state) => {
      return {
        ...state,
        isGridView: view,
      };
    });
  };

  // const onDropDownChange = (event) => {
  //   let { name, value } = event;

  //   if (value.length) {
  //     props.onPageSizeChange(utilities.extractFirstValueOfArray(value));
  //   }
  // };

  const onSearch = () => {
    if (state.searchKeyword.value.trim()) {
      props.searchByName(state.searchKeyword.value.trim());
    } else {
      props.searchByName(null);
    }
  };

  const onChange = (event) => {
    props.onChange({
      name: event.target.name,
      value: event.target.value,
      searchKey: state.searchKeyword.value.trim()
        ? state.searchKeyword.value.trim()
        : null,
    });
  };

  // const openDetailModal = (employeeEIN) => {
  //   props.openSetModal(
  //     <ErsCaseStatusDetailModal employeeEIN={employeeEIN} {...props} />
  //   );
  // };

  return (
    <>
      <div className="Dashboard-Content">
        <div className="row">
          <div className="back-btn-outer">
            <Backbutton />

            <div className="applicant-view-tab">
              <ul className="nav nav-pills">
                <li className="nav-item table-btn">
                  <a
                    onClick={() => onViewChange(false)}
                    className={
                      !state.isGridView
                        ? "nav-link active table-btn"
                        : "nav-link table-btn"
                    }
                  >
                    {props.context.t("CURRENT_ACTIVITY.Table.text")}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => onViewChange(true)}
                    className={
                      state.isGridView
                        ? "nav-link grid-btn active"
                        : "nav-link grid-btn"
                    }
                  >
                    {props.context.t("CURRENT_ACTIVITY.Grid.text")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {state.isGridView ? (
          <>
            <div className="Inner-cell">
            <DisplayEmployeeName context={props.context}/>
            <div class="row">
              <SearchComponent  searchKeyword={state.searchKeyword} handleChanges={handleChanges} context={props.context} onSearch={onSearch}/>
            </div>
              {/* <div className="row">
                <div className="pagesize-dropdown">
                  <DropdownComponent
                    name="pageSize"
                    options={PAGE_SIZE_DRP}
                    isMultiSelect={false}
                    option_key="pageSize"
                    option_display="pageSizeValue"
                    onChange={onDropDownChange}
                    values={[props.pageSize]}
                    simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                    selectAllText="Select All Options"
                    isSearchOption={false}
                  />
                </div>
              </div> */}
            </div>

            <div className="row">
            <span className="search-text">{props.context.t("CurrentActivity.All.Employees.Text")}</span>
              <div className="col-12 col-md-12 col-lg-12">
                {/* <button className="file-upload mt-0 btn btn-primary">Short-term Disability</button>
              <button className="file-upload mt-0 btn btn-primary margin-left-15">Accomodation</button>
              <button className="file-upload mt-0 btn btn-primary margin-left-15">Workers Compensation</button> */}
                {/* <div className="col-3 col-md-3 col-lg-3">
                  <button className="file-upload mt-0 btn btn-primary">File History</button>
                </div>
                <div className="col-3 col-md-3 col-lg-3">
                  <button className="file-upload mt-0 btn btn-primary">File History</button>
                </div>
                <div className="col-3">
                  <button className="file-upload mt-0 btn btn-primary">File History</button>
                </div> */}
              </div>
              {Array.isArray(props.applicants) && props.applicants.length
                ? props.applicants
                  .filter((applicant) => applicant.employeeId.length)
                  .map((applicant) => (
                    <div
                      key={`${applicant.employeeId}-${applicant.fullName}`}
                      className="col-12 col-sm-12 col-md-12 col-lg-4"
                    >
                      <div className="s-box">
                        {
                          applicant.isForBackupUser &&
                          <strong className="float-right badge badge-success">Backup</strong>
                        }
                        <div className="srv-img">
                          <div className="display-name">
                            {applicant.fullName
                              ? utilities.convertIntoIconName(
                                applicant.fullName
                              )
                              : "-"}
                          </div>
                          <h2
                          // className="reset-pass"
                          // onClick={() =>
                          //   openDetailModal(applicant.employeeId)
                          // }
                          >
                            {applicant.fullName ? applicant.fullName : "-"}
                          </h2>
                          <small className="display-ein">
                            {applicant.employeeId
                              ? applicant.employeeId
                              : null}
                          </small>
                          <div>
                            <div
                              onClick={() =>
                                history.push(
                                  `/allcasedetails?ein=${applicant.employeeId}`
                                )
                              }
                              className="r-more"
                            >
                              {props.context.t("EE.CaseHistory.Text")}
                            </div>
                          </div>
                          <div>
                            <div
                              className="r-more"
                              onClick={() =>
                                onClickAttachment(applicant.employeeId)
                              }
                            >
                              {props.context.t("EE.Documents.Text")}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  ))
                : null}
            </div>
            <div>
              <span htmlFor="">{props.context.t("Attachment.TotalRows.Text")}: {props.totalRows}</span>

              <Pagination
                currentPage={props.currentPage}
                pageSize={props.pageSize}
                totalRows={props.totalRows}
                onClickPre={(pageNo) => {
                  onChange({
                    target: {
                      name: "currentPage",
                      value: pageNo,
                    },
                  });
                  utilities.scrollToTop();
                }}
                onClickNext={(pageNo) => {
                  onChange({
                    target: {
                      name: "currentPage",
                      value: pageNo,
                    },
                  });
                  utilities.scrollToTop();
                }}
                onClickPage={(pageNo) => {
                  onChange({
                    target: {
                      name: "currentPage",
                      value: pageNo,
                    },
                  });
                  utilities.scrollToTop();
                }}
              ></Pagination>
            </div>
          </>
        ) : (
          <CaseStatus context={props.context} />
        )}
      </div>
    </>
  );
};

export default ErsApplicantComponent;
